<template>
  <div class="choice-item mpn-ship" ref="subscription">
    <div class="box_title_area">
      <h3 class="service-title-b">구매 유형을 선택해주세요.</h3>
    </div>
    <div class="choice-abc choice-abc-renew">
      <div class="form_group-element">
        <span class="form_element-radio">
          <input
            type="radio"
            id="purchase-single"
            name="purchaseType"
            checked="checked"
            value="single"
            v-model="purchaseType"
            @change="changeSubscriptionInfo"
          />
          <label for="purchase-single" class="focus">1회 구매</label>
        </span>
        <span class="form_element-radio">
          <input
            type="radio"
            id="purchase-recurring"
            name="purchaseType"
            value="recurring"
            v-model="purchaseType"
            @change="changeSubscriptionInfo"
          />
          <label for="purchase-recurring" class="focus"
            >정기구매 (12개월)</label
          >
        </span>
      </div>
    </div>
    <div class="choice-abc-box">
      <div
        class="choice-abc-cont"
        id="buyCollect_one_cont"
        style="display: block"
        v-if="purchaseType == 'single'"
      >

        <!-- ASB-13103: [마이팩] 즉시결제 할부 기능 업데이트 -->
        <div class="box_title_area">
          <h3 class="service-title-b">결제 방법을 선택해주세요.</h3>
        </div>
        <div class="choice-abc">
          <div class="form_group-element">
              <span class="form_element-radio">
                  <input type="radio" id="paymentCollect_auto" name="paymentCollect" :checked="paymentType === 'auto'" v-model="paymentType" value="auto" @change="changeSubscriptionInfo">
                  <label for="paymentCollect_auto" class="paymentCollect_auto focus">상담 후 자동결제 <br class="mo_ver">(할부 불가)</label>
              </span>
              <span class="form_element-radio">
                <input type="radio" id="paymentCollect_direct" name="paymentCollect" :checked="paymentType === 'direct'"v-model="paymentType" value="direct"@change="changeSubscriptionInfo">
                <label for="paymentCollect_direct" class="paymentCollect_direct focus">상담 후 직접결제 <br class="mo_ver">(할부 가능)</label>
              </span>
          </div>
        </div>
        <!-- ASB-13103: [마이팩] 즉시결제 할부 기능 업데이트 -->

        <div class="box_title_area">
          <h3 class="service-title-b">신청 유형을 선택해주세요.</h3>
        </div>
        <div class="choice-abc">
          <div class="form_group-element">
            <span class="form_element-radio">
              <input
                type="radio"
                id="image-ship"
                name="aboCollect"
                checked="checked"
                value="VCALL"
                v-model="requestType"
                @change="changeSubscriptionInfo"
              />
              <label for="image-ship" class="image-ship focus"
                >채팅 상담 후 배달 수령</label
              >
            </span>
            <span class="form_element-radio">
              <input
                type="radio"
                id="visit-ship"
                name="aboCollect"
                value="ABC"
                v-model="requestType"
                @change="changeSubscriptionInfo"
              />
              <label for="visit-ship" class="visit-ship focus"
                >ABC 상담 후 수령</label
              >
            </span>
          </div>
          <ul v-if="requestType == 'VCALL'">
            <li class="choice_disc image-ship">
              <i></i>채팅 상담은 카카오톡을 통해서 진행되며, 마이팩 신청 완료 후 상담
              URL이 알림톡으로 발송됩니다.
            </li>
          </ul>
        </div>
        <a-b-c-section
          v-if="requestType == 'ABC'"
          v-model="abcCd"
          styleClass="abc-select-box"
        />
      </div>
      <div
        class="choice-abc-cont"
        id="buyCollect_regular_cont"
        style="display: block"
        v-if="purchaseType == 'recurring'"
      >
        <!-- S : 신청 유형 선택 영역 -->
        <div class="box_title_area">
          <h3 class="service-title-b">신청 유형을 선택해주세요.</h3>
        </div>
        <div class="choice-abc">
          <div class="form_group-element">
            <span class="form_element-radio">
              <input
                type="radio"
                id="image-ship"
                name="aboCollect"
                checked="checked"
                value="VCALL"
                v-model="requestType"
                @change="changeSubscriptionInfo"
              />
              <label for="image-ship" class="image-ship focus"
                >채팅 상담 후 배달 수령</label
              >
            </span>
            <span class="form_element-radio">
              <input
                type="radio"
                id="visit-ship"
                name="aboCollect"
                value="ABC"
                v-model="requestType"
                @change="changeSubscriptionInfo"
              />
              <label for="visit-ship" class="visit-ship focus"
                >ABC 상담 후 수령</label
              >
            </span>
          </div>
          <ul>
            <li v-if="requestType == 'VCALL'" class="choice_disc image-ship2">
              <i></i>채팅 상담은 카카오톡을 통해서 진행되며, 마이팩 신청 완료 후 상담
              URL이 알림톡으로 발송됩니다.
            </li>
            <li class="choice_disc image-ship2">
              <i></i>정기 구매의 경우 2회차 부터는 배달수령으로만 제품이
              배송됩니다.
            </li>
          </ul>
        </div>
        <a-b-c-section
          v-if="requestType == 'ABC'"
          v-model="abcCd"
          styleClass="abc-select-box2"
        >
          <ul>
            <li class="choice_disc">
              <i></i>정기 구매의 경우 2회차 부터는 배달수령으로만 제품이 배송됩니다.
            </li>
          </ul>
        </a-b-c-section>

        <div class="choice-abc-box2">
          <div class="box_title_area">
            <h3 class="service-title-b">정기 결제일을 선택해주세요.</h3>
          </div>
          <billing-date-section v-model="billingDate" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import ChatAgreement from "@/views/composition/main/step3/ChatAgreement.vue";
import BillingDateSection from "@/views/composition/main/step3/BillingDateSection.vue";
import ABCSection from "@/views/composition/main/step3/ABCSection.vue";
import { log } from "@/utils/common";

export default {
  name: "SubscriptionSection",
  components: {
    // ChatAgreement,
    BillingDateSection,
    ABCSection,
  },
  props: {
    value: {
      type: Object,
      default: {
        purchaseType: "single",
        requestType: "VCALL",
        abcCd: "bundang",
        billingDate: "",
        billingStatus: "",
      },
    },
  },
  data() {
    return {
      purchaseType: this.value.purchaseType,
      requestType: this.value.requestType,
      abcCd: this.value.abcCd,
      billingDate: this.value.billingDate,
      billingStatus: this.value.billingStatus,
      abcInfos: [],
      paymentType: "auto", // auto, direct
    };
  },
  watch: {
    abcCd() {
      this.changeSubscriptionInfo();
    },
    billingDate() {
      this.changeSubscriptionInfo();
    },
    purchaseType() {
      this.$emit("update-min-height");
    },
    requestType() {
      this.$emit("update-min-height");
    },
    value(subscription) {
      this.purchaseType = subscription.purchaseType;
      this.requestType = subscription.requestType;
      this.abcCd = subscription.abcCd;
      this.billingDate = subscription.billingDate;
      this.billingStatus = subscription.billingStatus;
    },
  },
  computed: {
    currentAbcCd() {
      return this.requestType === "VCALL" ? "bundang" : this.abcCd;
    },
    currentBillingDate() {
      return this.purchaseType === "recurring" ? this.billingDate : "";
    },
    currentbillingStatus() {
      return this.purchaseType === "recurring" ? this.billingStatus || 'ACTIVE' : "";
    },
  },
  methods: {
    changeSubscriptionInfo() {
      this.$emit("update-subscription-info", {
        purchaseType: this.purchaseType,
        requestType: this.requestType,
        abcCd: this.currentAbcCd,
        billingDate: this.currentBillingDate,
        billingStatus: this.currentbillingStatus,
        paymentType: this.purchaseType === 'single' ? this.paymentType : "",
      });
    },
  },
};
</script>
